import React from 'react';
import { styled, useTheme } from '@material-ui/core/styles';

import './Button.scss';
import { DSTheme } from '../../styles/themes/types';

interface PlatformButtonProps {
  onClick: () => void;
  Image: React.ElementType;
  name: string;
  selected?: boolean;
}

export const StyledPlatformButton = styled('button')(({ theme }: { theme: DSTheme }) => ({
  width: '80px',
  height: '80px',
  backgroundColor: theme.palette.background.elevation2,
  boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
  border: 0,
  borderRadius: '16px',
  color: theme.palette.text.primary,
  cursor: 'pointer',

  '&.selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

const PlatformButton: React.FC<PlatformButtonProps> = ({ onClick, Image, name, selected }) => {
  const theme = useTheme();
  const strokeColour = selected ? theme.palette.primary.contrastText : theme.palette.text.primary;

  return (
    <StyledPlatformButton
      onClick={onClick}
      className={`${selected ? 'selected' : ''}`}
      type="button"
    >
      <Image stroke={strokeColour} />
      <div className="ds-platform-button-text">{name}</div>
    </StyledPlatformButton>
  );
};

export default PlatformButton;
